<template>
  <div id="minibanners-shelves">
    <shelf
      v-if="!isBlank(shelves) && shelves[0]"
      :shelf-products="shelves[0]"
      :use-cache="cacheFirstShelf"
      :first-shelf="true"
    />
    <mini-banners
      v-if="!isBlank(alternatedMinibanners)"
      :minibanners="alternatedMinibanners.slice(0, 3)"
    />
    <mini-banners
      v-if="alternatedMinibanners.length > 3"
      :minibanners="alternatedMinibanners.slice(3, 6)"
    />
    <shelf
      v-if="shelves.length > 1"
      :shelf-products="shelves[1]"
      :class="'shelf--light-teal'"
    />

    <div v-if="$route.path !== '/' && shelves.length > 2">
      <shelf
        v-for="(shelf, idx) in shelves.slice(2)"
        :key="idx"
        :shelf-products="shelf"
      />
    </div>
  </div>
</template>

<script>
import isBlank from '~/utils/isBlank'
import MiniBanners from '~/components/pages/mini-banners/MiniBanners.vue'
import Shelf from '~/components/pages/shelf/Shelf.vue'
import sortableObjectArrayByIds from '~/utils/sortableObjectArrayByIds'
import isPresent from '~/utils/isPresent'

export default {
  name: 'MinibannersShelves',
  components: {
    MiniBanners,
    Shelf,
  },
  props: {
    minibanners: {
      type: Array,
      required: true,
    },
    showcases: {
      type: Object,
      required: true,
    },
    cacheFirstShelf: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shelves: [],
      alternatedMinibanners: [],
    }
  },
  created() {
    if (isPresent(this.showcases))
      this.shelves = this.showcases[Object.keys(this.showcases)[0]]

    this.alternatedMinibanners = this.minibanners

    if (this.$route.query.mini_banners) {
      const ids = this.$route.query.mini_banners.split(',')

      if (this.minibanners[0].id) {
        this.alternatedMinibanners = sortableObjectArrayByIds(
          ids,
          this.alternatedMinibanners
        )
      }
    }
  },
  methods: { isBlank },
}
</script>
